module.exports = __webpack_public_path__ + "static/media/red-cabbage.337a1979.webp";